import React from "react";
import "./Contact.css";

const officeDetails = [
  {
    title: "Nadiad, VS Jewellery Casting",
    rows: [
      {
        label: "Contact Person",
        value: "Rushi V. Soni",
        extra: "Jaimin V. Soni",
      },
      {
        label: "",
        value: "+91 9558559494",
        extra: "+91 9724215191",
      },
      {
        label: "Address",
        value:
          "Modisanth, Baini Pole opp. Wadi-387001 Nadiad, Gujarat, India.",
      },
      {
        label: "Phone(o)",
        value: "0268-2569569, 0268-6542303",
      },
    ],
  },
  {
    title: "Vadodara, VS Jewel Cast",
    rows: [
      {
        label: "Contact Person",
        value: "Priyansh V. Soni",
      },
      {
        label: "Address",
        value:
          "MZ-2 Darshan Complex, Shamal Becher Pole, Mandvi, Vadodara, Gujarat, India",
      },
      {
        label: "Phone",
        value: "+91 9979736364, 0265-6542079",
      },
      {
        label: "Email",
        value: "info@vsjewelcast.com, priyanshsoni@yahoo.com",
      },
    ],
  },
];

export default function Contact() {
  return (
    <>
      <main className="content-area">
        <section className="contact-panel">
          <div className="contact-header">
            <h2>Contact Us</h2>
          </div>

          <div className="contact-grid">
            {officeDetails.map((office) => (
              <article className="contact-card" key={office.title}>
                <h3>{office.title}</h3>

                <div className="contact-rows">
                  {office.rows.map((row, index) => (
                    <div className="contact-row" key={`${office.title}-${index}`}>
                      <div className="contact-label">{row.label ? `${row.label} :` : ""}</div>
                      <div className="contact-value">
                        <span>{row.value}</span>
                        {row.extra ? <span>{row.extra}</span> : null}
                      </div>
                    </div>
                  ))}
                </div>
              </article>
            ))}
          </div>
        </section>
      </main>
    </>
  );
}
